const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 列表
export const auditSmsContent = params =>
  request.post(BASE_URL + '/smsMessage/auditSmsContent', params)

export const pushSmsContent = params =>
  request.post(BASE_URL + '/smsMessage/pushSmsContent', params)
// 获取进度接口
export const getMapProcess = params => request(BASE_URL + '/smsMessage/getMapProcess', { params })
// 获取进度接口
export const resendSmsRecord = params => request(BASE_URL + '/smsMessage/resendSmsRecord', { params })
// 获取进度接口
export const addSmsEnt = params => request.post(BASE_URL + '/smsEntTemp/addSmsEnt', params)
// 消息选择企业-取消消息选择的企业
export const cancelSmsEntTemp = params => request(BASE_URL + '/smsEntTemp/cancelSmsEntTemp', { params })

// 钉钉消息
export const getDingTalkRecordByPage = params => request(BASE_URL + '/dingTalk/getDingTalkRecordByPage', { params })

